import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RequestList from "../../components/request/requestsList/RequestsList";
import useRedirectLoggedOutUser from "../../customHook/useRedirectLoggedOutUser";
import { selectIsLoggedIn } from "../../redux/features/auth/authSlice";
import { getRequests } from "../../redux/features/request/requestSlice";
// import "./RequestList.scss";
const Requests = () => {
  useRedirectLoggedOutUser("/login");
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { requests, isLoading, isError, message } = useSelector(
    (state) => state.request
  );

  useEffect(() => {
    if (isLoggedIn === true) {
      dispatch(getRequests());
    }

    if (isError) {
      console.log(message);
    }
  }, [isLoggedIn, isError, message, dispatch]);

  return (
    <div>
      <RequestList requests={requests} isLoading={isLoading} />
    </div>
  );
};

export default Requests;